// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-content[data-v-b6bfa6d2]{min-height:100%;position:fixed;overflow-y:scroll;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
